import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";

export default function Sources() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/sources").then((r) => setD(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Indépendance & gratuité fonctionnelle" title="Sources, conditions & coûts" desc="Inventaire transparent de chaque source et service externe. Aucune API payante n'est présentée comme gratuite ; les quotas sont ceux des fournisseurs, jamais des restrictions commerciales MADENGI." />
      <div className="panel overflow-auto" data-testid="sources-table">
        <table className="w-full text-xs">
          <thead className="eyebrow text-left sticky top-0 bg-card"><tr>{["Nom", "Fonction", "Accès", "Conditions", "Quota", "Coût", "Alternative open source", "Remplacement"].map((h) => <th key={h} className="p-2">{h}</th>)}</tr></thead>
          <tbody>{(d?.active || []).map((s) => (
            <tr key={s.name} className="border-t align-top">
              <td className="p-2 font-semibold"><a href={s.url} target="_blank" rel="noreferrer" className="hover:text-primary">{s.name}</a></td>
              <td>{s.function}</td><td>{s.access}</td><td>{s.terms}</td><td className="font-mono">{s.quota}</td>
              <td className={s.cost.toUpperCase().includes("PAYANT") ? "text-amber-500 font-semibold" : "text-emerald-500"}>{s.cost}</td><td>{s.oss_alternative}</td><td>{s.fallback}</td>
            </tr>))}</tbody>
        </table>
      </div>
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <div className="panel p-4"><div className="eyebrow mb-2">Intégrations planifiées / non intégrées</div>
          {(d?.planned || []).map((p) => <div key={p.name} className="text-xs py-1.5 border-t flex justify-between"><span>{p.name}</span><span className="text-muted-foreground">{p.status}</span></div>)}</div>
        <div className="panel p-4"><div className="eyebrow mb-2">Connecteurs par type de donnée</div>
          {Object.entries(d?.types || {}).map(([k, v]) => <div key={k} className="text-[11px] py-1 border-t"><span className="font-mono text-primary">{k}</span> : {v.join(", ")}</div>)}</div>
      </div>
    </div>
  );
}
